import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { recordNavigation } from 'utils/supportContext/actionLog';

export function useSupportActionLogRouting(): void {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChangeComplete = (url: string) => recordNavigation(url);

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router.events]);
}
